import script from "./process-item.vue?vue&type=script&setup=true&lang=js"
export * from "./process-item.vue?vue&type=script&setup=true&lang=js"

import "./process-item.vue?vue&type=style&index=0&id=35c7e898&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c7e898"]])

export default __exports__